import { analytics } from '@sendgrid/bloodhound';
import { Experiment } from '../constants';
import { signupConfidenceAudience } from './audience';
import { roll } from '../roll';

export const signupConfidenceExperimentId = 'signup_confidence_experiment';
export const signupConfidenceControlId = 'signup_confidence_control';
export const signupConfidenceVariation1Id = 'signup_confidence_variation_1';
export const signupConfidenceVariation2Id = 'signup_confidence_variation_2';

/**
 * Using the experimentToken and experimentId, bucket the user into a variation
 * @param {string} experimentToken part of the key used to create the hash
 * @param {string} experimentId part of the key used to create the hash
 * @returns {string} variation id
 */
const signupConfidenceBucket = (
  experimentToken: string,
  experimentId: string
): string => {
  const bucketKey = `${experimentToken}_${experimentId}`;
  const variationAssignment = roll(bucketKey);
  let variationId: string;

  // 33.33 control : 33.33 variation 1 : 33.33 variation 2
  if (variationAssignment <= 0.3333) {
    variationId = signupConfidenceControlId;
  } else if (variationAssignment <= 0.6666) {
    variationId = signupConfidenceVariation1Id;
  } else {
    variationId = signupConfidenceVariation2Id;
  }

  // We need to wait for segment analytics to load before firing events
  const waitForAnalytics = () => {
    return new Promise(resolve => {
      setTimeout(resolve, 1500);
    });
  };

  (async () => {
    await waitForAnalytics();
    analytics.track({
      event: 'experiment activated',
      properties: {
        experimentId: signupConfidenceExperimentId,
        variationId,
        page: 'account-inputs'
      }
    });
  })();

  return variationId;
};

export const signupConfidenceExperiment = {
  id: signupConfidenceExperimentId,
  description:
    'signup confidence experiment - https://jira.sendgrid.net/browse/CL-283',
  bucket: signupConfidenceBucket,
  audiences: [signupConfidenceAudience]
} as Experiment;

export default { signupConfidenceExperiment };
